import { ENVIRONMENTS } from "./environment.common"
import { ENVS } from "./environment"

export function apiEndpointV1() {
  switch(ENVS.ENVIRONMENT) {
    case ENVIRONMENTS.LOCAL:
    case ENVIRONMENTS.DEV:
      return "https://myvw-bff-ds.itd.vw.com.br/api/v1/"
    case ENVIRONMENTS.UAT:
      return "https://myvw-bff-qs.itd.vw.com.br/api/v1/"
    case ENVIRONMENTS.PRODUCTION:
    default:
      return "https://myvw-bff.itd.vw.com.br/api/v1/"
  }
}

export function apiEndpointV2() {
  switch(ENVS.ENVIRONMENT) {
    case ENVIRONMENTS.LOCAL:
    case ENVIRONMENTS.DEV:
      return "https://myvw-bff-ds.itd.vw.com.br/api/v2/"
    case ENVIRONMENTS.UAT:
      return "https://myvw-bff-qs.itd.vw.com.br/api/v2/"
    case ENVIRONMENTS.PRODUCTION:
    default:
      return "https://myvw-bff.itd.vw.com.br/api/v2/"
  }
}


export function basePath() {
  return "/";
}

/**
 * API Enpoints
 */
export function IntegratorAPI() {
  return apiEndpointV1() + 'settings/integrator'
}
export function LoginAPI() {
  return apiEndpointV1() + "login/";
}
export const UsersAPI = {
  FIND: apiEndpointV1() + "users"
};

export const BadgesAPI = {
  FIND: apiEndpointV2() + "badges/"
};

export const VehiclesAPI = {
  FIND: apiEndpointV1() + "vehicles/"
};

export function identityKitOption() {
  switch(ENVS.ENVIRONMENT) {
    case ENVIRONMENTS.LOCAL: return {
      "clientId": "3ad74830-3c95-4667-9773-6083b8286c93@apps_vw-dilab_com",
      "clientSecret": "dd37f2d99483be3dde370bc5ae767071b17f3c28852b8e8815bc2dae012d3181",
      "urlCallback": "http://localhost:3000/login-redirect",
      "urlVwId": "https://identity.na.vwgroup.io/oidc/v1/",
      "urlLogoutCallback": "http://localhost:3000/login"
    }
    case ENVIRONMENTS.DEV: return {
      "clientId": "3ad74830-3c95-4667-9773-6083b8286c93@apps_vw-dilab_com",
      "clientSecret": "dd37f2d99483be3dde370bc5ae767071b17f3c28852b8e8815bc2dae012d3181",
      "urlCallback": "https://selodigital-ds.itd.vw.com.br/login-redirect",
      "urlVwId": "https://identity.na.vwgroup.io/oidc/v1/",
      "urlLogoutCallback": "https://selodigital-ds.itd.vw.com.br/login"
    }
    case ENVIRONMENTS.UAT: return {
      "clientId": "3ad74830-3c95-4667-9773-6083b8286c93@apps_vw-dilab_com",
      "clientSecret": "dd37f2d99483be3dde370bc5ae767071b17f3c28852b8e8815bc2dae012d3181",
      "urlCallback": "https://selodigital-qs.itd.vw.com.br/login-redirect",
      "urlVwId": "https://identity.na.vwgroup.io/oidc/v1/",
      "urlLogoutCallback": "https://selodigital-qs.itd.vw.com.br/login"
    }
    case ENVIRONMENTS.PRODUCTION:
    default: return {
      "clientId": "3ad74830-3c95-4667-9773-6083b8286c93@apps_vw-dilab_com",
      "clientSecret": "dd37f2d99483be3dde370bc5ae767071b17f3c28852b8e8815bc2dae012d3181",
      "urlCallback": "https://selodigital.itd.vw.com.br/login-redirect",
      "urlVwId": "https://identity.na.vwgroup.io/oidc/v1/",
      "urlLogoutCallback": "https://selodigital.itd.vw.com.br/login"
    }
  }
}

export function getLogoutUrl() {
  let token = JSON.parse(localStorage.getItem('user-data')).token
  let urlLogoutCallback = identityKitOption().urlLogoutCallback;
  let VWURLAuth = identityKitOption().urlVwId;
  return VWURLAuth + "logout?id_token_hint=" + token + "&post_logout_redirect_uri=" + urlLogoutCallback;
}
